<h2 mat-dialog-title i18n>Undo action</h2>

<mat-dialog-content>

  @if ($error()) {
    <rsr-alert variant="error">
      <p>{{ $error() }}</p>
    </rsr-alert>
  }

  @if ($operationInProgress()) {
    <rsr-loading text="Operation in progress" i18n-text></rsr-loading>
  }

  @if ($success()) {
    <rsr-alert variant="success">
      <p i18n>Undo action has been processed successfully.</p>
    </rsr-alert>
  }

  @if (!$success() && !$operationInProgress()) {
    <p i18n>Would you like to undo this action?</p>
  }

</mat-dialog-content>

<mat-dialog-actions>
  @if (!$success() && !$operationInProgress()) {
    <button mat-flat-button color="primary" (click)="onUndo()" i18n>Undo</button>
  }
  <button mat-stroked-button (click)="onCancel()" i18n>{{ $success() ? 'Close' : 'Cancel' }}</button>
</mat-dialog-actions>
